<template>

  <div
      v-bind:class="['step py-2 pt-md-3 pb-md-3 '+ cssClass, isStepActive ? 'active' : '',isStepFinish ? 'filled' : '', lastDemandStepDisabled ? 'disabled' : '']">
    <div :class="['stepLink', lastDemandStepDisabled ? 'disabled':'']">
      <div class="row">
        <div class="col-3 col-sm-2 col-md-12 ml-4 ml-md-0 pl-md-3">
          <div class="stepCircle ml-2  ml-md-auto mx-md-auto">
            <div class="icon-wrapper d-none  m-0 p-0 d-flex justify-content-center align-items-center">
              <i class="fa check-icon d-none text-white">
                <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.25 6L6 9.75L13.5 2.25" stroke="white" stroke-width="2" stroke-linecap="square"/>
                </svg>
              </i>
            </div>
            <div class="activeCircle">
              <div class="step-number">{{stepNumber}}</div>
            </div>
          </div>
        </div>
        <div class="col col-md-12">
          <div class="stepName text-left text-md-center">
            {{ t('steps.' + stepName) }}
          </div>
        </div>
      </div>


    </div>

  </div>


</template>

<script>
import {store} from "../../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'

export default {
  name: "StepElement",
  props: ['stepName', 'cssClass', 'stepNumber'],
  data() {
    return {
      store
    }
  },
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  methods: {
    /*  goToStep(stepName) {
        this.store.goToStep(stepName);
      }*/

  },

  computed: {
    isStepActive() {
      return this.store.form.currentStep === this.stepName;
    },
    isStepFinish() {
      return this.store.form.steps[this.stepName].filled === true;
    },
    lastDemandStepDisabled() {
      if (this.store.order.type === 'demand' && (this.stepName === 'stepFour' || this.stepName === 'stepThree')) return true;
    },
  }
}
</script>

<style lang="scss" scoped>
.step {

  .stepLink {
    display: block;
    color: #333;
    cursor: pointer;

    &:hover {
      text-decoration: none;
      color: #333;
    }

  }

}
</style>